import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'div[linkTileComponent]',
  templateUrl: './link-tile.component.html',

})
export class LinkTileComponent implements OnInit {

  @Input() routerLink: string;
  @Input() linkText: string;
  @Input() iconCSS: string = 'fa fa-taxi'

  constructor() { }



  ngOnInit(): void {
  }

}
